import { isValidTypeformUrl } from "./isValidTypeformUrl";

export function extractTypeformId(url) {
  if (!isValidTypeformUrl(url)) return null;

  try {
    const urlObj = new URL(url);

    const pathMatch = urlObj.pathname.match(/\/to\/([^/?#]+)/);
    if (pathMatch && pathMatch[1]) {
      return pathMatch[1];
    }

    const directMatch = urlObj.pathname.match(/^\/([^/?#]+)$/);
    if (directMatch && directMatch[1]) {
      return directMatch[1];
    }

    return null;
  } catch {
    return null;
  }
}
